import React from 'react';
import classes from './AvailableMeals.module.css'
import Card from '../UI/Card'
import SingleMeal from './SingleMeal/SingleMeal';

const DUMMY_MEALS = [
    {
      id: 'm1',
      name: 'Sushi',
      description: 'Finest fish and veggies',
      price: 22.99,
    },
    {
      id: 'm2',
      name: 'Schnitzel',
      description: 'A german specialty!',
      price: 16.5,
    },
    {
      id: 'm3',
      name: 'Barbecue Burger',
      description: 'American, raw, meaty',
      price: 12.99,
    },
    {
      id: 'm4',
      name: 'Green Bowl',
      description: 'Healthy...and green...',
      price: 18.99,
    },
  ];
  const foodLists = DUMMY_MEALS.map(meal => 
  <SingleMeal 
    key={meal.id} 
    id={meal.id}
    name={meal.name} 
    description={meal.description}
    price={meal.price} 
    />)

const AvailableMeals = () => {
    return (
        <section className={classes.meals}>
            <Card>
                {foodLists}
            </Card>
        </section>
    );
};

export default AvailableMeals;